import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RegistrationService} from '../shared/services/registrationService/registration.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-recap-form',
  templateUrl: './recap-form.component.html',
  styleUrls: ['./recap-form.component.css']
})
export class RecapFormComponent implements OnInit {

  @Input() registration;
  @Output() sendCheck = new EventEmitter();

  checkRegistration = false;

  constructor(private registrationService: RegistrationService,
              private router: Router) { }

  ngOnInit() {
  }

  sendChange() {
    this.sendCheck.emit(this.checkRegistration);
  }

  goBack() {
    this.registrationService.goBack = true;
    this.router.navigate(['/home']);
  }

}
